import { UserMenu } from './UserMenu'
import './Header.css'

interface HeaderProps {
  onMenuToggle: () => void
}

/**
 * ヘッダーコンポーネント
 *
 * - デスクトップ: ロゴ + ユーザーメニュー
 * - モバイル: ハンバーガーボタン + ロゴ + ユーザーメニュー
 */
export function Header({ onMenuToggle }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-left">
        <button
          className="hamburger-button"
          onClick={onMenuToggle}
          aria-label="メニューを開く"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        <h1 className="app-title">Noahstagram</h1>
      </div>

      <UserMenu />
    </header>
  )
}
